<template>
    <div>
        <form @submit.prevent="OnSubmit"
              @keydown="form.errors.clear($event.target.name)">
            <div class="pl-4 pr-4">
                <label>
                    {{trans.get('production.work_unit_code')}}:
                </label>
                <input :placeholder="trans.get('production.work_unit_code')"
                       type="text"
                       class="w-full text-left"
                       id="id_reparto"
                       name="id_reparto"
                       v-model="form.id_reparto">

                <span class="alert alert-danger"
                      v-if="form.errors.has('id_reparto')"
                      v-text="form.errors.get('id_reparto')">
                    </span>
            </div>

            <div class="pl-4 pr-4">
                <label>
                    {{trans.get('production.work_unit')}}:
                </label>
                <input :placeholder="trans.get('production.work_unit')"
                       type="text"
                       class="w-full text-left"
                       id="descrizione"
                       name="descrizione"
                       v-model="form.descrizione">

                <span class="alert alert-danger"
                      v-if="form.errors.has('descrizione')"
                      v-text="form.errors.get('descrizione')">
                </span>

            </div>

            <div class="flex justify-center p-8">
                <button class="btn is-aitems-700"
                        type="submit"
                        :class="loading ? 'loader' : ''">
                    {{trans.get('production.crea')}}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        name: "WorkUnitCreator",
        props: ['modal'],

        data() {
            return {
                form: new Form({
                    id_reparto: '',
                    descrizione: ''
                }),
                loading: false,
            }
        },

        methods: {
            OnSubmit() {
                console.log('Sono qui!');
                axios.post('/workunits/store', this.form)
                    .then(response => {
                        console.log(response);
                        swal.fire('Work Unit created!');
                        this.$emit('wu-has-been-created', response.data);
                    })
                    .catch(error => {
                        console.log(error.response.data);
                        this.form.onFail(error.response.data.errors);
                    });
            },

        }
    }
</script>

<style lang="scss" scoped>

    .alert {

        @apply text-xs mt-1 capitalize;

    }

    .alert-danger {

        @apply text-red-400;

    }

</style>